export const VacancyInitialValues = {
  vacancyTitle: "",
  experienceLevel: "",
  department: "",
};
